import type { CSSProperties } from "react";

/**
 * The small parts every card shows the same way (F61), on the Workflow graph's measured
 * cards and in a step's input cards: its type, and the line under its name. A caller that
 * lays the card out itself passes its own classes; the words are the view model's.
 */

/** "Label list", "Artifact", "Agent step": the card's type, whole on hover, with its hint where it has one. */
export function CardTypeLabel({ type, hint = null, className = "app-text-muted text-xs" }: { type: string; hint?: string | null; className?: string }) {
  return (
    <span className={className} title={hint === null ? type : `${type}: ${hint}`}>
      {type}
    </span>
  );
}

/** "Version 1.2.0 · Made by hand", and on the graph what an input holds; whole on hover. */
export function CardMetaLine({ text, className = "app-text-muted text-xs", style }: { text: string; className?: string; style?: CSSProperties }) {
  return (
    <p className={className} style={style} title={text}>
      {text}
    </p>
  );
}
